export enum TaskRelatedEntityType {
  DOCUMENT_PERIOD = 'document-period',
  REPORT_WHOLESALE = 'report-wholesale',
  REPORT_RETAIL = 'report-retail',
  BIOTRACK_CREDS = 'biotrack-credentials',
  METRC_CREDS = 'license'
}
